export { LegacyPathRedirect as default } from "src/components/LegacyPathRedirect";
